/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LocalizationProvider, StaticDatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Backdrop, IconButton, Modal, TextField } from "@mui/material";
import {
  getAssets,
  getTimeZone,
  htmlParse,
  swalError,
} from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import moment from "moment-timezone";
import Link from "next/link";
import React, { Fragment, useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import Select from "react-select";
import styles from "./profile.module.scss";

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "46px",
    boxShadow: state.isFocused ? "none" : "none",
    borderColor: "none",
    "&:hover": { borderColor: "none" }, // border style on hover
    borderColor: state.isFocused ? "#f5f8fa" : "#f5f8fa",
    backgroundColor: "#f5f8fa",
    fontSize: "14px",
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    fontSize: "14px",
    transition: "all 0.3s",
    color: state.isSelected ? "#F47F20" : "#B5B5C3",
    backgroundColor: state.isSelected
      ? "#F5F6FC"
      : state.isFocused
      ? "#fff"
      : provided.backgroundColor,
    "&:hover": {
      backgroundColor: "#F5F6FC",
      color: "#F47F20",
    },
  }),
  menuList: (base) => ({
    ...base,
    "::-webkit-scrollbar": {
      width: "5px",
      height: "6px",
      overflow: "visible",
      cursor: "pointer",
      background: "transparent",
      borderRadius: "10px",
    },

    "::-webkit-scrollbar-thumb": {
      background: "rgb(202, 202, 202)",
      borderRadius: "10px",
      cursor: "pointer",
    },
  }),
};

export const PersonProfile = ({ data, profileType, ...props }) => {
  const tZone = getTimeZone();
  const [value, setValue] = React.useState(new Date());
  const [currentTzone, setCurrentTzone] = useState(moment.tz.guess());
  const [open, setOpen] = useState(false);
  const [showInMobile, setShowInMobile] = useState(false);
  const [timeSlot, setTimeslot] = useState();
  const [profileInfo, setProfileInfo] = useState({});
  const [index, setIndex] = useState();

  const getProfile = async () => {
    await API.get(`/user/any-profile?userType=${profileType}&id=${data?.id}`)
      .then((res) => {
        if (!res.error) {
          setProfileInfo(res.data);
        }
      })
      .catch((error) => {
        swalError("Something went wrong");
      });
  };

  useEffect(() => {
    if (data?.id && profileType) {
      getProfile();
    }
  }, [data?.id, profileType]);

  const handleSubmit = async () => {
    const payload = {
      date: value,
      counsellorId: data?.id,
      timezone: currentTzone,
    };
    await API.post("/student/counsellor-appointment/time-list", payload)
      .then((res) => {
        if (!res.error) {
          setTimeslot(res.data);
        }
      })
      .catch((error) => {
        swalError("Something went wrong");
      });
  };

  useEffect(() => {
    if (data?.id && value && currentTzone && profileType === "counsellor") {
      handleSubmit();
    }
  }, [data?.id, value, currentTzone, profileType]);

  function formatAMPM(time) {
    // return time;
    const hour = time.split(":");
    let hrs = parseInt(hour[0]);
    var ampm = hrs >= 12 ? "pm" : "am";
    hrs = hrs % 12;
    hrs = hrs ? hrs : 12; // the hour '0' should be '12'
    var strTime = hrs + ":" + hour[1] + " " + ampm;
    return strTime;
  }

  const handleOpen = () => {
    setOpen(true);
    document.body.classList.add("popOpen");
    handleSubmit();
  };
  const handleClose = () => {
    setOpen(false);
    document.body.classList.remove("popOpen");
    setIndex();
  };

  return (
    <div className={styles.profile_wrapper}>
      <div className={styles.image_wrapper}>
        <img
          src={
            data.profileImage
              ? data.profileImage
              : getAssets("assets/student-avatar-big.png")
          }
          alt={data?.name ?? ""}
        />
      </div>
      <h2>{data.name}</h2>

      {profileType && profileType == "counsellor" && (
        <Fragment>
          {/*<div className={styles.stars_wrapper}>
            <div className={styles.stars}>
              <AiFillStar />
              <AiFillStar />
              <AiFillStar />
              <AiFillStar />
              <AiFillStar />
            </div>
            <div className={styles.star_num}>(5.0)</div>
      </div>*/}
          <div className={styles.profile_bio}>
            {profileInfo && profileInfo?.bio && htmlParse(profileInfo?.bio)}
            {profileInfo && profileInfo?.bio && (
              <Link legacyBehavior href={`/app/student/counsellor/${data?.id}`}>
                <a className={styles.read_more}>Read More</a>
              </Link>
            )}
          </div>
          {profileInfo?.workingCountry && <h5>Working Country</h5>}
          {profileInfo?.workingCountry &&
            profileInfo?.workingCountry?.length > 0 && (
              <div className={styles.country_wrapper}>
                {profileInfo.workingCountry &&
                  profileInfo.workingCountry.map((item, i) => (
                    <h6 className={styles.country} key={i}>
                      {item}
                    </h6>
                  ))}
                {/*<h6 className={styles.country}>{data?.countryName}</h6>*/}
              </div>
            )}

          <button
            onClick={handleOpen}
            className={`btn btn-primary ${styles.book_appiontment}`}
          >
            Book Appointment
          </button>
        </Fragment>
      )}

      {profileType && profileType == "student" && (
        <Fragment>
          {/*<div className={styles.stars_wrapper}>
            <div className={styles.stars}>
              <AiFillStar />
              <AiFillStar />
              <AiFillStar />
              <AiFillStar />
              <AiFillStar />
            </div>
            <div className={styles.star_num}>(5.0)</div>
      </div>*/}

          <div style={{ margin: "25px 0" }}>
            {profileInfo?.preferences?.courselevel && <h5>Course Level</h5>}
            {profileInfo?.preferences?.courselevel?.levelName && (
              <div className={styles.country_wrapper}>
                <h6 className={styles.country}>
                  {profileInfo?.preferences?.courselevel?.levelName}
                </h6>
              </div>
            )}
          </div>

          <div style={{ margin: "25px 0" }}>
            {profileInfo?.preferences?.countryPreferences && (
              <h5>Country Preferences</h5>
            )}
            {profileInfo?.preferences?.countryPreferences &&
              profileInfo?.preferences?.countryPreferences?.length > 0 && (
                <div className={styles.country_wrapper}>
                  {profileInfo?.preferences?.countryPreferences &&
                    profileInfo?.preferences?.countryPreferences?.map(
                      (item, i) => (
                        <h6 className={styles.country} key={i}>
                          {item}
                        </h6>
                      )
                    )}
                </div>
              )}
          </div>

          <div style={{ margin: "25px 0" }}>
            {profileInfo?.preferences?.studyPreferences && (
              <h5>Preferred Courses</h5>
            )}
            {profileInfo?.preferences?.studyPreferences &&
              profileInfo?.preferences?.studyPreferences?.length > 0 && (
                <div className={styles.country_wrapper}>
                  {profileInfo?.preferences?.studyPreferences &&
                    profileInfo?.preferences?.studyPreferences?.map(
                      (item, i) => (
                        <h6 className={styles.country} key={i}>
                          {item}
                        </h6>
                      )
                    )}
                </div>
              )}
          </div>

          <div style={{ margin: "25px 0" }}>
            {profileInfo?.preferences?.specialization && (
              <h5>Specialization</h5>
            )}
            {profileInfo?.preferences?.specialization?.specializationName && (
              <div className={styles.country_wrapper}>
                <h6 className={styles.country}>
                  {profileInfo?.preferences?.specialization?.specializationName}
                </h6>
              </div>
            )}
          </div>

          <div style={{ margin: "25px 0" }}>
            {profileInfo?.preferences?.intakePreferences && <h5>Intake</h5>}
            {profileInfo?.preferences?.intakePreferences &&
              profileInfo?.preferences?.intakePreferences?.length > 0 && (
                <div className={styles.country_wrapper}>
                  {profileInfo?.preferences?.intakePreferences &&
                    profileInfo?.preferences?.intakePreferences?.map(
                      (item, i) => {
                        const { year, data } = item;
                        let last = Object.keys(data).length - 1;
                        const payload = {
                          year: year,
                          from: data[Object.keys(data)[0]],
                          to: data[Object.keys(data)[last]],
                        };

                        return (
                          <h6 className={styles.country} key={i}>
                            {`${payload.from}-${payload.to}, ${payload.year}`}
                          </h6>
                        );
                      }
                    )}
                </div>
              )}
          </div>

          <div style={{ margin: "25px 0" }}>
            {profileInfo?.preferences?.budget && <h5>Budget</h5>}
            {profileInfo?.preferences?.budget && (
              <div className={styles.country_wrapper}>
                <h6 className={styles.country}>
                  {profileInfo?.preferences?.budget}
                </h6>
              </div>
            )}
          </div>

          <div style={{ margin: "25px 0" }}>
            {profileInfo?.preferences?.objective && <h5>Objective</h5>}
            {profileInfo?.preferences?.objective && (
              <div className={styles.country_wrapper}>
                <h6 className={styles.country}>
                  {profileInfo?.preferences?.objective?.objectivePurpose}
                </h6>
              </div>
            )}
          </div>
        </Fragment>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className={`modal ${styles.modal_custom_width}`}>
          <button
            className={`${styles.cross_icon} cross_icon`}
            onClick={handleClose}
          >
            <FiX />
          </button>
          <div className={styles.appoint_modal}>
            {/* <div className={styles.appoint_modal_left}>
              <h3 className={styles.appoint_title}>Book an Appointment</h3>
              <p className={styles.appoint_desc}> &nbsp; </p>
            </div> */}
            <div className={styles.appoint_modal_right}>
              <h3 className={styles.appoint_title}>Select a Date & Time</h3>
              <div className={styles.appoint_calender_and_time_wrapper}>
                <div
                  className={`${styles.calender_and_time_zone_wrapper} ${
                    showInMobile ? styles.active : ""
                  }`}
                >
                  <div style={{ maxHeight: "310px" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <StaticDatePicker
                        className={"appointModalDatePicker"}
                        displayStaticWrapperAs="desktop"
                        openTo="day"
                        minDate={new Date()}
                        value={value}
                        onChange={(newValue) => {
                          setValue(newValue);
                          setShowInMobile(true);
                          setIndex();
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className={styles.time_zone_wrapper}>
                    <label className={styles.label}>Select Time Zone</label>
                    <Select
                      menuPlacement="top"
                      placeholder="Select Timezone"
                      styles={customStyles}
                      options={tZone}
                      value={
                        currentTzone && tZone
                          ? tZone.filter((tz) => tz.value == currentTzone)
                          : ""
                      }
                      onChange={(item) => {
                        setCurrentTzone(item.value);
                        setIndex();
                      }}
                    />
                  </div>
                </div>

                <div
                  className={`${styles.appoint_time_wrapper} ${
                    showInMobile ? styles.active : ""
                  }`}
                >
                  <div className={styles.back_icon_and_date_wrapper}>
                    <IconButton
                      onClick={() => setShowInMobile(false)}
                      className={styles.back_btn}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                    <div className={styles.appoint_time_title}>
                      {new Date(value).toDateString()}
                    </div>
                  </div>
                  <div className={styles.appoint_time_list_wrapper}>
                    <ul>
                      {timeSlot && timeSlot.length > 0 ? (
                        timeSlot?.map((item, i) => {
                          return (
                            <li key={i}>
                              <button
                                onClick={() => setIndex(i)}
                                className={`${styles.appoint_time_btn} ${
                                  index === i ? styles.active : ""
                                }`}
                              >
                                {formatAMPM(item?.startTime)}-
                                {formatAMPM(item?.endTime)}
                              </button>
                              <button
                                className={`${styles.confirm_btn} ${
                                  index === i ? styles.active : ""
                                } btn btn-secondary btn-bg`}
                                onClick={() => {
                                  handleFormSubmit(item?.timeId);
                                }}
                              >
                                Confirm
                              </button>
                            </li>
                          );
                        })
                      ) : (
                        <li className={styles.no_record}>
                          "No Appoinment Schedule"
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PersonProfile;
